import { useIoCContext } from "@context/IoCContext/IoCContext";
import { Types } from "@ioc/types";
import {
  Button,
  CircularProgress,
  createStyles,
  Dialog,
  DialogActions,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { IRemoveActiveCostService } from "@modules/costs/models/IRemoveActiveCostService";
import AppError from "@utils/AppError";
import { useSnackbar } from "notistack";
import React, { useCallback, useState } from "react";
import { useActiveSettingsCostsContext } from "./ActiveSettingsCostsContext";

const useStyles = makeStyles(
  ({ typography: { pxToRem, ...typography }, ...theme }) =>
    createStyles({
      loading: {
        width: "2rem !important",
        height: "2rem !important",
      },
    })
);

const DialogRemoveSettingsCostActive: React.FC = ({ children, ...props }) => {
  const classes = useStyles();
  const activeCostsContext = useActiveSettingsCostsContext();
  const { enqueueSnackbar } = useSnackbar();
  const iocContext = useIoCContext();

  const removeActiveCostService = iocContext.serviceContainer.get<
    IRemoveActiveCostService
  >(Types.Costs.IRemoveActiveCostService);

  const [loadingDelete, setLoadingDelete] = useState(false);

  const onClose = useCallback(() => {
    activeCostsContext.setOpenDialogDelete({ id: null, open: false });
  }, [activeCostsContext]);

  const deleteCost = useCallback(async () => {
    if (!activeCostsContext.openDialogDelete.id) return;
    try {
      setLoadingDelete(true);
      await removeActiveCostService.execute(
        activeCostsContext.openDialogDelete.id
      );
      enqueueSnackbar("Custo removido com sucesso!", { variant: "success" });
      activeCostsContext.fetchActiveCosts();
      onClose();
    } catch (error) {
      if (error instanceof AppError) {
        return enqueueSnackbar(error.message, { variant: error.variant });
      }
      enqueueSnackbar("Ocorreu um erro ao remover custo ativo", {
        variant: "error",
      });
    } finally {
      setLoadingDelete(false);
    }
  }, [activeCostsContext, enqueueSnackbar, onClose, removeActiveCostService]);

  console.log({ activeCostsContext });

  return (
    <Dialog open={activeCostsContext.openDialogDelete.open}>
      <DialogTitle>Deseja remover o centro de custo?</DialogTitle>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={deleteCost}
          variant="contained"
          color="primary"
          startIcon={
            loadingDelete && (
              <CircularProgress className={classes.loading} color="secondary" />
            )
          }
        >
          Remover
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { DialogRemoveSettingsCostActive };
